/** Release 3 EXP-1 (lane C) — bulk "Download zip" dialog: pack originals, or apply a preset to the image entries. */
import { useState } from 'react';
import { Dialog } from '@/components/Dialog';
import { Button } from '@/components/Button';
import { useDownloadPresets, type ImageTransform } from '@/lib/api/queries';
import { useSessionStore } from '@/stores/session';
import { describeTransform } from './exportModel';

export function ZipPresetDialog({ count, onClose, onConfirm }: { count: number; onClose: () => void; onConfirm: (presetId: string | null) => void }) {
  const wsId = useSessionStore((s) => s.workspace?.id);
  const presets = useDownloadPresets(wsId);
  const [picked, setPicked] = useState<string>('');
  return (
    <Dialog
      open
      onClose={onClose}
      title={`Download ${count} as zip`}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={() => onConfirm(picked || null)} data-zip-confirm>
            Start zip
          </Button>
        </>
      }
    >
      <fieldset className="space-y-2" data-zip-preset-dialog>
        <legend className="mb-1 text-sm text-fg-muted">Images in the archive</legend>
        <label className="flex cursor-pointer gap-2 rounded-md border border-line p-2 text-sm has-[:checked]:border-accent">
          <input type="radio" name="zip-preset" value="" checked={picked === ''} onChange={() => setPicked('')} data-zip-preset="" />
          <span>
            <span className="font-medium">Original files</span>
            <span className="block text-xs text-fg-subtle">Every asset as uploaded.</span>
          </span>
        </label>
        {(presets.data ?? []).map((p) => (
          <label key={p.id} className="flex cursor-pointer gap-2 rounded-md border border-line p-2 text-sm has-[:checked]:border-accent">
            <input type="radio" name="zip-preset" value={p.id} checked={picked === p.id} onChange={() => setPicked(p.id)} data-zip-preset={p.id} />
            <span>
              <span className="font-medium">{p.name}</span>
              <span className="block text-xs text-fg-subtle">{describeTransform(p.transform as ImageTransform)} · other files stay original</span>
            </span>
          </label>
        ))}
        {presets.data && presets.data.length === 0 && <p className="text-xs text-fg-subtle">No export presets yet — an admin can add them under Settings › Export presets.</p>}
      </fieldset>
    </Dialog>
  );
}
